module.exports = __webpack_public_path__ + "static/img/undraw_svg_2.97b43ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/undraw_svg_2.svg
// module id = vged
// module chunks = 0